export default __webpack_public_path__ + "static/Survive-Japan-Knowing-Only-English-Phrase-book-75523c65564064e0528f8fc4f9ec0798.jpg";